export const INVALID_CODE_ERROR_MESSAGE = 'Invalid code';
